export default __webpack_public_path__ + "static/media/downfile.8d407e5b.svg";